import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Announcement } from 'types/announcements';

interface IHomeScreen {
	announcements: Announcement[];
}

const initialState: IHomeScreen = {
	announcements: [],
};

export const homeScreenSlice = createSlice({
	name: 'homeScreen',
	initialState,
	reducers: {
		setAnnouncements: (state, action: PayloadAction<Announcement[]>) => {
			state.announcements = action.payload;
		},
	},
});

export const { setAnnouncements } = homeScreenSlice.actions;

export default homeScreenSlice.reducer;
